import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../context/auth-context'

import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { PerEmpty } from '../../components/custom_components/Empty'
import { getCompanySettingsPermissionInfo } from '../../shared/permissions/permission-helper'
import { labelSorter } from '../../shared/sortUtils'
import { CompanySettingsBuTabs } from './CompanySettingsBuTabs'
import './index.less'

export const CompanySettingsBUView: FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { t } = useTranslation()
  const { user } = useAuth()

  const companySettingsPermissions = getCompanySettingsPermissionInfo(user.roles || [])
  const managedBusinessUnits = [...user.managedBusinessUnits].sort((a, b) => labelSorter(a.displayName, b.displayName))

  return (
    <ContentContainer collapsed={collapsed}>
      {!!managedBusinessUnits.length ? (
        <CompanySettingsBuTabs managedBusinessUnits={managedBusinessUnits} companySettingsPermissions={companySettingsPermissions} />
      ) : (
        <BackgroundBox r color="white" className="fullWidth fullHeight">
          <PerEmpty
            icon="smileyConcerned_stroke"
            iconColor="error"
            iconSize="xxl"
            heading={t('companySettingsView.noBusinessUnit')}
            info={t('page.error.pageUnavailable.info')}
          />
        </BackgroundBox>
      )}
    </ContentContainer>
  )
}
